import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function comentariosComboReducer(state= initialState.comentariosCombo, action){
	switch(action.type){
		case types.GET_COMENTARIOSS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}